import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "mt-2 d-flex" }
const _hoisted_2 = {
  class: "flex-fill",
  style: {"max-width":"500px"}
}
const _hoisted_3 = { class: "font-weight-bold ml-2" }

import HelpIcon from "~/cabinet/vue/interface/form/HelpIcon.vue";
import {__} from "~/ts/library/Translate";
import OperatorApplicationServerSideConfigInterface
    from "~/operatorApplication/ts/service/OperatorApplicationServerSideConfigInterface";
import ServerSideConfigUsedWarning from "~/operatorApplication/vue/config/ServerSideConfigUsedWarning.vue";


const __default__ = {
    name: "OperatorApplicationConfigChatForServerSide"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    configuration: {},
    isServerSide: { type: Boolean }
  },
  setup(__props: any) {

let props = __props;



return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.isServerSide)
      ? (_openBlock(), _createBlock(ServerSideConfigUsedWarning, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form, { "label-position": "top" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: __props.configuration.showSecondsInChat,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.configuration.showSecondsInChat) = $event)),
              disabled: __props.isServerSide
            }, null, 8, ["modelValue", "disabled"]),
            _createTextVNode(" " + _toDisplayString(_unref(__)('Отображать секунды в чате')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: __props.configuration.showDialogsInChat,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.configuration.showDialogsInChat) = $event)),
              disabled: __props.isServerSide
            }, null, 8, ["modelValue", "disabled"]),
            _createTextVNode(" " + _toDisplayString(_unref(__)('Отображать разбиение истории общения на диалоги')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: __props.configuration.showSystemMessagesInChat,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.configuration.showSystemMessagesInChat) = $event)),
              disabled: __props.isServerSide
            }, null, 8, ["modelValue", "disabled"]),
            _createTextVNode(" " + _toDisplayString(_unref(__)('Отображать системные сообщения')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: __props.configuration.autoSuggestTemplates,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.configuration.autoSuggestTemplates) = $event)),
              disabled: __props.isServerSide
            }, null, 8, ["modelValue", "disabled"]),
            _createTextVNode(" " + _toDisplayString(_unref(__)('Искать подходящий шаблон при наборе ответа')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: __props.configuration.suggestAutoRememberedTemplates,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.configuration.suggestAutoRememberedTemplates) = $event)),
              disabled: __props.isServerSide
            }, null, 8, ["modelValue", "disabled"]),
            _createTextVNode(" " + _toDisplayString(_unref(__)('Предлагать подстановку предыдущих ответов оператора')), 1)
          ]),
          _: 1
        }),
        (__props.configuration.suggestAutoRememberedTemplates)
          ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: __props.configuration.suggestAutoRememberedTemplatesFromSameSiteOnline,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((__props.configuration.suggestAutoRememberedTemplatesFromSameSiteOnline) = $event)),
                  disabled: __props.isServerSide
                }, null, 8, ["modelValue", "disabled"]),
                _createTextVNode(" " + _toDisplayString(_unref(__)('Предлагать подстановку предыдущих ответов только с того же сайта')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: __props.configuration.prependTemplateToText,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((__props.configuration.prependTemplateToText) = $event)),
              disabled: __props.isServerSide
            }, null, 8, ["modelValue", "disabled"]),
            _createTextVNode(" " + _toDisplayString(_unref(__)('Подставлять выбранный вручную шаблон перед набранным текстом сообщения')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: __props.configuration.hideNotFilledClientFieldsEnabled,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((__props.configuration.hideNotFilledClientFieldsEnabled) = $event)),
              disabled: __props.isServerSide
            }, null, 8, ["modelValue", "disabled"]),
            _createTextVNode(" " + _toDisplayString(_unref(__)('Скрывать незаполненные дополнительные поля')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: __props.configuration.symbolCountInTextareaEnabled,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((__props.configuration.symbolCountInTextareaEnabled) = $event)),
              disabled: __props.isServerSide
            }, null, 8, ["modelValue", "disabled"]),
            _createTextVNode(" " + _toDisplayString(_unref(__)('Показывать счетчик символов в сообщении для каналов с ограничением максимальной длины сообщения')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: __props.configuration.showAnsweredNotInTimeMessages,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((__props.configuration.showAnsweredNotInTimeMessages) = $event)),
              disabled: __props.isServerSide
            }, null, 8, ["modelValue", "disabled"]),
            _createTextVNode(" " + _toDisplayString(_unref(__)('Отмечать сообщения, отправленные оператором позже допустимого времени ответа')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: __props.configuration.stickyDialogInfoEnabledAlways,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((__props.configuration.stickyDialogInfoEnabledAlways) = $event)),
              disabled: __props.isServerSide
            }, null, 8, ["modelValue", "disabled"]),
            _createTextVNode(" " + _toDisplayString(_unref(__)('Всегда показывать информацию о диалоге поверх истории переписки')), 1)
          ]),
          _: 1
        }),
        (!__props.configuration.stickyDialogInfoEnabledAlways)
          ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: __props.configuration.stickyDialogInfoEnabled,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((__props.configuration.stickyDialogInfoEnabled) = $event)),
                  disabled: __props.isServerSide
                }, null, 8, ["modelValue", "disabled"]),
                _createTextVNode(" " + _toDisplayString(_unref(__)('Показывать информацию о диалоге во время пролистывания чата')) + " ", 1),
                (__props.configuration.stickyDialogInfoEnabled)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString((__props.configuration.stickyDialogInfoTimeout / 1000).toFixed(1)) + " " + _toDisplayString(_unref(__)("сек")) + " ", 1),
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_switch, {
                            modelValue: __props.configuration.stickyDialogInfoEnabled,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((__props.configuration.stickyDialogInfoEnabled) = $event)),
                            disabled: __props.isServerSide,
                            style: {"visibility":"hidden"}
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_el_slider, {
                            modelValue: __props.configuration.stickyDialogInfoTimeout,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((__props.configuration.stickyDialogInfoTimeout) = $event)),
                            disabled: __props.isServerSide,
                            min: 500,
                            max: 10000,
                            step: 500,
                            "show-tooltip": false
                          }, null, 8, ["modelValue", "disabled"])
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "after-sticky-dialog-info"),
        _createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)('Ссылка с информацией по IP')) + " ", 1),
            _createVNode(HelpIcon, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(__)('Чтобы подставить в ссылку IP адрес посетителя, добавьте в ссылку переменную')) + " ", 1),
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "font-weight-bold" }, "[ip]", -1))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: __props.configuration.ipInfoUrl,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((__props.configuration.ipInfoUrl) = $event)),
              disabled: __props.isServerSide
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _renderSlot(_ctx.$slots, "after-ip-info-url"),
        _createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(__)('Количество отображаемых строк в цитируемом сообщении, пока оно свёрнуто')) + ": ", 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(__props.configuration.chatMessageReplyLines), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_slider, {
              modelValue: __props.configuration.chatMessageReplyLines,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((__props.configuration.chatMessageReplyLines) = $event)),
              disabled: __props.isServerSide,
              step: 1,
              min: 1,
              max: 20,
              style: {"max-width":"550px"}
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _renderSlot(_ctx.$slots, "after-reply-lines")
      ]),
      _: 3
    })
  ]))
}
}

})